import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { setCreditCardAction } from './store/credit-card.actions';
import { getCreditCardSelectors } from './store/credit-card.selectors';
import { ICreditCardState } from './store/credit-card.state';
import { Observable } from 'rxjs';
import { ICreditCardData } from 'src/app/modules/interfaces/credit-card.interface';
import { CreditCardService } from 'src/app/services/credit-cards.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.scss'],
})
export class CreditCardComponent implements OnInit {
  @Output() formSaved = new EventEmitter<void>();
  formsId: number;
  creditCardData: ICreditCardData = {
    id: 0,
    has_credit_card: null,
    credit_card_quantity: null,
    has_miles_per_cards: null,
  };

  isLoading = true;
  isSaving = false;
  saveButtonText = 'Salvar';
  saveButtonClass = 'btn-primary';

  dataState$: Observable<ICreditCardState>;
  dataState: ICreditCardState;

  constructor(
    private store: Store,
    private creditCardService: CreditCardService
  ) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.getState();
    this.loadCreditCardData()
  }

  loadCreditCardData(): void {
    this.isLoading = true;
    this.creditCardService.getCreditCardData(this.formsId).subscribe((response) => {
      if (response) {
        this.creditCardData = {
          id: response.id,
          has_credit_card: response.has_credit_card,
          credit_card_quantity: response.credit_card_quantity || null,
          has_miles_per_cards: response.has_miles_per_cards || null,
        };
        this.saveState()
      }
    });
  }

  saveForm(): void {
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';

    const updateData: Partial<ICreditCardData> = {
      has_credit_card: this.creditCardData.has_credit_card,
      credit_card_quantity: Number(this.creditCardData.credit_card_quantity),
      has_miles_per_cards: this.creditCardData.has_miles_per_cards,
    };

    this.creditCardService
      .updateCreditCardData(this.formsId, this.creditCardData.id, updateData)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.saveButtonText = 'Salvo';
          this.saveButtonClass = 'btn-primary';
          this.saveState()
          this.formSaved.emit();
        },
        error: () => {
          this.isSaving = false;
          this.saveButtonText = 'Erro ao salvar';
          this.saveButtonClass = 'btn-danger';
        },
      });
  }

  saveState(): void {
    this.dataState = {
      ...this.dataState,
      check: true,
      creditCard: this.creditCardData.has_credit_card === 1,
      cards: Number(this.creditCardData.credit_card_quantity) || 0,
      miles: this.creditCardData.has_miles_per_cards === 1,
    };

    this.setState(this.dataState);
  }
  
  updateField(value: any, field: keyof ICreditCardData): void {
    this.creditCardData = {
      ...this.creditCardData,
      [field]: value,
    };
    this.onFieldChange();
  }

  onFieldChange(): void {
    if (!this.isSaving) {
      this.saveButtonText = 'Salvar';
      this.saveButtonClass = 'btn-primary';
    }
  }

  startTrial(): void {
    this.setState(this.dataState);
  }

  setState(data: ICreditCardState) {
    this.store.dispatch(setCreditCardAction(data));
    this.isLoading = false;
  }

  getState() {
    this.dataState$ = this.store.select(getCreditCardSelectors);

    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...(this.dataState = value),
      };
    });
  }

  setValuesForm(): void {
    this.dataState.check = false;
    if (this.dataState.creditCard != undefined) {
      this.dataState.check = true;
    }
    this.setState(this.dataState);
  }
}
